import { dateEqualsDateItem } from 'Angular/features/components/date-controls/single-date-picker/utils/single-date-picker-utils';
import * as i0 from "@angular/core";
/**
 * Is Date Item Selected Pipe
 *
 * Checks if a given SingleDatePickerItem has the same year, month, and day as a selected date.
 */
export class isDateItemSelectedPipe {
    transform(dateItem, selectedDate) {
        return !!selectedDate && dateEqualsDateItem(selectedDate, dateItem);
    }
}
isDateItemSelectedPipe.ɵfac = function isDateItemSelectedPipe_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || isDateItemSelectedPipe)(); };
isDateItemSelectedPipe.ɵpipe = /*@__PURE__*/ i0.ɵɵdefinePipe({ name: "isDateItemSelected", type: isDateItemSelectedPipe, pure: true, standalone: false });
